/* eslint-disable import/prefer-default-export */
// function to validate that a value is not null, undefined, or an empty string
// trim also to remove white spaces when comparing
export function stringHasValue(value) {
  return value !== null && value !== undefined && String(value)?.trim() !== '';
}
